




import BillingService from '@/api/BillingService';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';
import {
  EBillingStatusTypes,
  EBusinessUserType
} from '@/store/modules/businessTypes';
import { getBillingIsPending } from '@/utils/billing';
import eventBus from '@/utils/eventBus';
import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class BillingModel extends Vue {
  billingService = new BillingService();

  loadingBillingUpgrade = false;

  get billingStatus() {
    const business =
      this.$store.getters['business/getBusinessInfo'].business || {};

    return business.subscriptionStatus;
  }

  get isBillingModuleV4() {
    return this.$store.getters['flags/getFlags'].includes(
      flagKeys.billingModuleV4
    );
  }

  get showCoinNetworkTag() {
    if (
      !this.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV2)
    )
      return false;

    return this.billingStatus !== EBillingStatusTypes.UNAVAILABLE;
  }

  get inactiveBilling() {
    if (
      !this.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV2)
    )
      return false;

    return (
      this.billingStatus === EBillingStatusTypes.UNSUBSCRIBED ||
      getBillingIsPending()
    );
  }

  async onClickUpgrade({
    onSuccess,
    props
  }: {
    onSuccess?: () => void;
    props?: {
      welcomeCtaText: string;
      origin: string;
      action?: 'Acceptance' | 'Reactivation';
    };
  }) {
    if (
      this.$store.getters['business/getManagerRole'] !== EBusinessUserType.OWNER
    ) {
      this.$notification(
        "You don't have permission to upgrade your account",
        'error'
      );
      return;
    }

    const modal =
      (props && props.action) ||
      (this.billingStatus === EBillingStatusTypes.UNAVAILABLE ||
        getBillingIsPending())
        ? 'Acceptance'
        : 'Reactivation';

    try {
      this.loadingBillingUpgrade = true;

      const {
        overview,
        features
      } = await this.billingService.getOverviewAndActivedFeatures(
        modal !== 'Reactivation'
      );

      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `coinNetwork${modal}Modal`,
          hideCancelButton: false,
          icon: '',
          mobileFullScreen: true
        }),
        {
          subscription: overview,
          features,
          onSuccess: onSuccess,
          ...props
        }
      );
    } finally {
      this.loadingBillingUpgrade = false;
    }
  }
}
